"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _reactContenteditable = _interopRequireDefault(require("react-contenteditable")),
    _Button = _interopRequireDefault(require("../Button")),
    _LabelWrapper = _interopRequireDefault(require("../LabelWrapper")),
    _Text = _interopRequireDefault(require("../Text"));

require("./styles/_number-changer.scss");

function onClick(a, b) {
  var c = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : {},
      d = c.increment;
  return function () {
    var c = d ? 1 : -1;
    a(b + c);
  };
}

function onChange(a, b) {
  return function (c) {
    var d = c.target.value;
    b && +d > b || a(+d || 0);
  };
}

function sanitiseInput(a) {
  return function (b) {
    var c = Number.isNaN,
        d = b.key;
    ("Backspace" !== d || 0 === a) && c(+d) && (b.preventDefault(), b.stopPropagation());
  };
}

function NumberChanger(a) {
  var b = a.value,
      c = void 0 === b ? 0 : b,
      d = a.onChangeNumber,
      e = a.disabled,
      f = a.label,
      g = a.suffixLabel,
      h = void 0 === g ? "" : g,
      i = a.max,
      j = a.hideValue,
      k = a.labelProps,
      l = e || "number" == typeof i && c >= i;
  return _react["default"].createElement(_LabelWrapper["default"], (0, _extends2["default"])({}, k, {
    divContainer: !0,
    className: "number-changer__label-wrapper",
    label: f
  }), _react["default"].createElement("div", {
    className: "number-changer"
  }, _react["default"].createElement(_Button["default"], {
    type: "TERTIARY",
    className: (0, _classnames["default"])("number-changer__minus", {
      "number-changer__minus--disabled": 0 === c || e
    }),
    disabled: 0 === c || e,
    onClick: onClick(d, c),
    prefix: "remove"
  }), _react["default"].createElement("div", {
    className: "number-changer__text"
  }, !j && _react["default"].createElement(_reactContenteditable["default"], {
    className: "text text--button text--centered number-changer__text__value",
    html: "".concat(c),
    tagName: "span",
    onChange: onChange(d),
    onKeyDown: sanitiseInput(c)
  }), h && _react["default"].createElement(_Text["default"], {
    button: !0
  }, h)), _react["default"].createElement(_Button["default"], {
    type: "TERTIARY",
    className: (0, _classnames["default"])("number-changer__add", {
      "number-changer__add--disabled": l
    }),
    onClick: l ? void 0 : onClick(d, c, {
      increment: !0
    }),
    disabled: l,
    prefix: "addfat"
  })));
}

var _default = (0, _react.memo)(NumberChanger);

exports["default"] = _default;